/**
 * Helper function to open an attachment in a new tab.
 * @param attachmentURL - The URL of the attachment to be opened.
 * @param isAppWebView - Whether the current environment is a app webview.
 */
export const openAttachmentInNewTab = (
  attachmentURL: string,
  isAppWebView: boolean
) => {
  if (typeof window === "undefined") return;
  if (!attachmentURL?.trim()) return;

  const a = document.createElement("a");
  a.href = attachmentURL;
  a.target = isAppWebView ? "_self" : "_blank";
  a.rel = "noopener noreferrer";

  document.body.appendChild(a);
  a.click();
  a.remove();
};
